import { render, staticRenderFns } from "./slide-panel.vue?vue&type=template&id=39af8bef&scoped=true&"
import script from "./slide-panel.vue?vue&type=script&lang=js&"
export * from "./slide-panel.vue?vue&type=script&lang=js&"
import style0 from "./slide-panel.vue?vue&type=style&index=0&id=39af8bef&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39af8bef",
  null
  
)

export default component.exports